(() => {
  const sectionName = 'banner-with-slider-ds';

  if (sectionName in Shopify.theme.sections.registered) {
    const sections = document.querySelectorAll(`[data-section-type=${sectionName}]`);

    sections.forEach((section, index) => {
      if (index !== 0) {
        const linkTag = section.querySelector('link');
        const scriptTag = section.querySelector('script');

        linkTag.remove();
        scriptTag.remove();
      }
    });
  } else {
    const selector = {
      slider: '.banner-with-slider-ds--slider',
    };

    const slider = document.querySelector(selector.slider);
    const slickSettings = {
      infinite: true,
      arrows: false,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      responsive: [
        {
          breakpoint: 480,
        },
      ]
    };

    if (slider) {
      slickSettings.autoplay = slider.dataset.autoPlay;
      slickSettings.autoplaySpeed = slider.dataset.playSpeed;
    }
  
    $(slider).slick(slickSettings);

    Shopify.theme.sections.register(sectionName);
  }
})()
